var exports = {
  "Oc": "chatPortalContainer__9KyXOP",
  "B$": "menuPortalContainer__OY2LnW",
  "FG": "embeddedMenuPortalContainer__9NWrlt",
};

module.exports = exports;
